import React, {useState} from 'react';

import {RtSampleEmailPageResult} from '../../../../server/routes/monitoring.js'

interface MonitoringSampleEmailProps {
	server: string;
	pageData: unknown;
}

export default function MonitoringSampleEmail({pageData}: MonitoringSampleEmailProps) {

	const [data, setData] = useState(pageData as RtSampleEmailPageResult);

	return (
	<>
		<section className="section section-sm">
			<div className="container">
				<div className="row row-50">
					<div className="col-md-8 col-lg-8 col-xl-8">
						<h4 style={{wordWrap: 'break-word'}}>See a Real Security Alert in Action</h4>
						<p>
						This sample email shows how you'll be notified when a new vulnerability affects your website's technology stack. (Website name hidden for privacy.)
						</p>
					</div>
					<div className="col-md-8 col-lg-8 col-xl-8" style={{border: "1px solid grey", padding: "20px"}}>
						<img src="/s/img/SecurityUpdate.png" width="801" height="582" style={{width:'auto'}} alt="Security Update Email Sample"/>
					</div>
				</div>       
				<div className="row row-50">
				<div className="col-md-8 col-lg-8 col-xl-8">
						<h4 style={{wordWrap: 'break-word'}}>Real-Time Tech Change Notification – Sample Email</h4>
						<p>
						Here's an example of how we alert you when your site's technology changes. Stay informed and in control. (Website name hidden for privacy.)
						</p>
					</div>
					<div className="col-md-8 col-lg-8 col-xl-8" style={{border: "1px solid grey", padding: "20px"}}>
						<img src="/s/img/TechnologyUpdate.png" width="784" height="610" style={{width:'auto'}} alt="Technology Update Email Sample"/>
					</div>
				</div>       
			</div> 
		</section>
		<br/>
		<br/>
	</>
	)
}
